<template>
    <div>
        <div class="order-details-in" >
            <!-- <div class="loading" style="text-align: center">
                <Loading :isLoading="isLoading"></Loading>
            </div> -->
            <div class="main" :style="{height:clientHeight-262+'px'}">
                <div class="about">
                    <div class="title">发票详情</div>
                    <table>
                        <tbody>
                            <tr>
                                <!-- <td>订单号</td>
                                <td>{{list.OrderOrBillNo}}</td> -->
                                <td>开票状态</td>
                                <td colspan="3">{{list.InvoiceStatus}}</td>
                            </tr>
                            <tr>
                                <td>抬头类型</td>
                                <td>{{list.InvoiceTitle}}</td>
                                <td>{{list.InvoiceTitle=='个人'?'姓名':'公司名称'}}</td>
                                <td>{{list.InvoiceName}}</td>
                            </tr>
                            <tr>
                                <td>结算类型</td>
                                <td>{{list.SettlementType}}</td>
                                <td>发票金额</td>
                                <td>{{list.Accounts}}{{list.Currency}}</td>
                            </tr>
                            <tr>
                                <td>发票项目</td>
                                <td>{{list.InvoiceItem}}</td>
                                <td>发票种类</td>
                                <td>{{list.InvoiceKind}}</td>
                            </tr>
                            <tr>
                                <td>纳税人识别号</td>
                                <td>{{list.TaxpayerIdentifyNo}}</td>                                
                                <td>邮箱地址</td>
                                <td>{{list.Email}}</td>
                            </tr>
                            <tr>
                                <td>发票备注</td>
                                <td colspan="3">{{list.Remark}}</td>
                                
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import Loading from './../../common/cmpnt/Loading/Loading.vue'//缓冲
export default {
    data(){
        return{
            list:{},
            isLoading:true,
            clientHeight:0

        }
    },
    created(){
        this.clientHeight=document.documentElement.clientHeight
    },
    components:{
        Loading,
    },
    methods:{
        initData(){
            var that = this;
            that.isLoading = true;
            
            that.getRequest({
                url: that.Api.InvoiceOrderNo+'?orderNO='+that.$route.params.orderNO,
                params: ''
            }).then(res => {
                that.isLoading = false;
                if (res && res.IsSuccess) {
                    that.list=res.Result
                    that.$nextTick(() => {
                            if(localStorage.getItem('lang')=='t'){
                                that.$zh_tran(localStorage.getItem('lang'))
                            }         
                        })
                } else {
                    this.error({title:'提示',content:res.Msg});
                }
            });
        },
    },
    mounted(){
        this.initData()
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/invoice/details.vue